import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Text } from "components";
import Footer1 from "components/Footer1";
import Header1 from "components/Header1";
import HomeOneNavbar from "components/HomeOneNavbar";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import { Button } from "components";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const LoginDoctor = () => {
  let navigate = useNavigate();
  const [selectHospital, setSelectHospital] = useState([]);
  const [showPass, setShowPass] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const handlePasswordToggle = () => {
    setShowPass(!showPass);
  };
  const domainName = window.location.hostname;
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid Email"
      )
      .required("Email is required"),
    login_password: Yup.string().required("Password is required"),
  });
  const headers = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const formik = useFormik({
    initialValues: {
      hospital_id: "",
      email: "",
      login_password: "",
      hospital_name: "",
      captchaToken: "",
      domain_name: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      onHandleSubmit(values);
    },
  });

  console.log(formik.values);

  const onHandleSubmit = async (values) => {
    console.log(values);
    if (!executeRecaptcha) {
      toast.error("reCAPTCHA not ready yet");
      return;
    }

    const tokenCaptcha = await executeRecaptcha("login");
    formik.values.captchaToken = tokenCaptcha;
    values.domain_name = domainName;

    axios
      .post(
        `
        ${process.env.REACT_APP_HOSPITAL_SERVER}/api/authentication/hospital-api/get-user-for-login`,
        values,
        headers
      )
      .then((response) => {
        console.log(response.data);
        const token = response.data.token;
        const array1 = response.data.userDetailList;
        setSelectHospital(array1);
        const headers1 = {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
        if (array1.length === 0) {
          console.log(response.data.userDetailList);
          const msg = "Please enter valid email";
          toast.error(msg, {
            autoClose: 1000,
            onClose: () => {},
          });
        } else if (array1.length < 2 && array1.length !== 0) {
          console.log(selectHospital);
          values.hospital_id = array1[0].hospital_id;
          const hosName = array1[0].hospital_name;
          sessionStorage.setItem("hospital_name", hosName);
          console.log(values);

          axios
            .post(
              "/api/authentication/hospital-api/user-login",
              values,
              headers1
            )
            .then((response) => {
              console.log(response.data);
              sessionStorage.setItem("token", response.data.token);
              sessionStorage.setItem("doctorId", response.data.id);
              sessionStorage.setItem("statusdoctor", response.data.status);
              const docAccesslist = response.data.module_access;
              sessionStorage.setItem(
                "docAccesslist",
                JSON.stringify(docAccesslist)
              );
              const hospitalMasterSettingList =
                response.data.hospital_master_setting;
              sessionStorage.setItem(
                "settings",
                JSON.stringify(hospitalMasterSettingList)
              );
              if (response.data.message === "Login Successfully!") {
                toast.success(response.data.message, {
                  autoClose: 500,
                  onClose: () => {
                    if (response.data.user_type_id === 2) {
                      navigate("/doctorAppointments");
                    } else {
                      navigate("/appointmentsmanagements");
                    }
                  },
                });
              } else {
                toast.error(response.data.message, {
                  autoClose: 2000,
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (formik.values.hospital_id != null) {
          console.log(values);
          sessionStorage.setItem("hospital_name", formik.values.hospital_name);
          axios
            .post(
              "/api/authentication/hospital-api/user-login",
              values,
              headers1
            )
            .then((response) => {
              console.log(response.data);
              sessionStorage.setItem("token", response.data.token);
              sessionStorage.setItem("statusdoctor", response.data.status);
              sessionStorage.setItem("doctorId", response.data.id);
              const hospitalMasterSettingList =
                response.data.hospital_master_setting;
              sessionStorage.setItem(
                "settings",
                JSON.stringify(hospitalMasterSettingList)
              );
              const docAccesslist = response.data.module_access;
              sessionStorage.setItem(
                "docAccesslist",
                JSON.stringify(docAccesslist)
              );

              if (response.data.message === "Login Successfully!") {
                toast.success(response.data.message, {
                  autoClose: 500,
                  onClose: () => {
                    if (response.data.user_type_id == 2) {
                      navigate("/doctorAppointments");
                    } else {
                      navigate("/appointmentsmanagements");
                    }
                  },
                });
              } else {
                if (formik.values.hospital_id == "") {
                  const message = "Please select hospital";
                  toast.warning(message, {
                    autoClose: 1000,
                  });
                } else {
                  toast.error(response.data.message, {
                    autoClose: 1000,
                  });
                }
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <div className="bg-white-A700_01 flex flex-col font-poppins items-center justify-start mx-auto w-full">
        <Header1 className="bg-white-A700_01 flex md:flex-row sm:flex-col flex-row md:gap-0 items-center justify-start md:px-5 w-full" />
        <HomeOneNavbar
          className="bg-cyan-400 flex md:flex-col flex-row md:gap-10 items-center justify-between max-w-full md:px-10 sm:gap-0 sm:px-5 py-[17px] w-full"
          searchimage="images/img_search_white_a700.svg"
        />
        <div>
          <ToastContainer />
          <div className="flex flex-col items-center justify-end p-[21px] sm:px-5 w-full">
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col gap-3 items-start justify-start mt-2.5 w-auto sm:w-full">
                <div className="flex flex-col gap-3 items-start justify-start w-auto">
                  <Text
                    className="text-2xl md:text-[22px] text-gray-900 sm:text-xl tracking-[0.20px] w-auto"
                    size="txtInterBold24"
                  >
                    Login for Hospital Users{" "}
                  </Text>
                </div>
                <div className="flex flex-col gap-4 items-start justify-start w-[404px] sm:w-full">
                  <label htmlFor="email">Enter Email</label>
                  <input
                    id="email"
                    name="email"
                    placeholder="Enter Your email"
                    className="md:h-auto placeholder:text-blue_gray-300 sm:h-auto text-base text-left w-full rounded-md p-2"
                    type="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="text-red-500">{formik.errors.email}</div>
                  ) : null}

                  <label htmlFor="login_password">Enter Password</label>
                  <div className="relative w-full">
                    <input
                      id="login_password"
                      name="login_password"
                      placeholder="Enter Your Password"
                      className="md:h-auto placeholder:text-blue_gray-300 sm:h-auto text-base rounded-md p-2 text-left w-full pr-10" // Added padding-right for the icon
                      type={showPass ? "text" : "password"}
                      value={formik.values.login_password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <div
                      className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer mr-8"
                      onClick={handlePasswordToggle}
                    >
                      {showPass ? (
                        <FaEye size={20} />
                      ) : (
                        <FaEyeSlash size={20} />
                      )}
                    </div>
                  </div>
                  {formik.touched.login_password &&
                  formik.errors.login_password ? (
                    <div className="text-red-500">
                      {formik.errors.login_password}
                    </div>
                  ) : null}
                </div>
                {selectHospital.length > 1 && (
                  <div className="flex flex-col gap-4 items-start justify-start w-[404px] sm:w-full">
                    <label htmlFor="password"> Select Hospital</label>
                    <Select
                      name="hospital_id"
                      options={selectHospital?.map((hospital) => ({
                        label: hospital.hospital_name,
                        value: hospital.hospital_id,
                        hospital_name: hospital.hospital_name,
                      }))}
                      className="bg-white-A700 border border-gray-200_02 border-solid h-9 rounded-[5px] w-full"
                      onChange={(selectedOption) => {
                        formik.setValues({
                          ...formik.values,
                          hospital_id: selectedOption.value,
                          hospital_name: selectedOption.hospital_name,
                        });
                      }}
                      onBlur={formik.handleBlur}
                      placeholder="Select Hospital"
                    />
                  </div>
                )}
                <div className="flex flex-row gap-[146px] items-end justify-between w-auto sm:w-full">
                  <a
                    className="text-blue-A700 text-right text-sm w-auto cursor-pointer"
                    onClick={() => navigate("/oTPFormDoctor")}
                  >
                    <Text size="txtInterBold14">Forgot Password?</Text>
                  </a>
                </div>
                <Button
                  type="submit"
                  className="cursor-pointer font-bold h-14 text-base text-center tracking-[0.20px] w-[404px] bg-cyan-400 py-3 px-2 hover:bg-cyan-500 rounded-md"
                  color="blue_A700"
                  size="lg"
                  variant="fill"
                >
                  Log In
                </Button>
              </div>
            </form>
          </div>
        </div>
        <Footer1 className="bg-cyan-400 flex items-center justify-center mt-[30px] md:px-5 w-full" />
      </div>
    </>
  );
};

export default LoginDoctor;
